export interface FAQRawItem {
    id: number;
    question: string;
    type: 'about' | 'howTo' | 'purchase' | 'device';
    answer: string;
}

export const faqList: FAQRawItem[] = [
    {
        id: 1,
        type: 'about',
        question: '什麼是共聲島？',
        answer: '<p><strong>「共聲島」為恆春半島首個實境數位聲音體驗</strong>，突破傳統導覽限制，大家只需要耳機和手機，即可按照自己的步調，隨時探索古城；同時能解謎闖關、集圖鑑，與店家互動，品味當地美食，結識居民，感受南國人情味，享受全新的旅程選擇。</p>',
    },
    {
        id: 2,
        type: 'about',
        question: '共聲島在哪裡玩？',
        answer: '<p>目前推出的<strong>主要範圍為恆春鎮上各城門周邊及老街區域</strong>，未來會再開發新的區域範圍，歡迎追蹤<a href="IG_URL">共聲島IG帳號</a>獲得最新消息。</p>',
    },
    {
        id: 3,
        type: 'about',
        question: '共聲島怎麼玩？',
        answer: '<p>共聲島主要玩法為「步行＋聆聽」，報名後，準備好手機及耳機即可出發。\n小提示：由於恆春夏季天氣炎熱，聆聽過程中，請別忘了多多補充水分、慎防中暑。</p>',
    },
    {
        id: 4,
        type: 'about',
        question: '共聲島體驗多少錢？',

        answer: `<p>戀の時光町（導覽版）採人數組別定價，人數越多每人越划算：
                    <ul>
                        <li>2 人 $1,800（$900 / 人）</li>
                        <li>4 人 $3,000（$750 / 人）</li>
                        <li>6 人 $4,200（$700 / 人）</li>
                        <li>8 人 $5,200（$650 / 人）</li>
                    </ul>
                    數位版體驗方案採包團制，詳情請聯絡客服信箱 info@launcher.com.tw。
                </p>`,
    },
    {
        id: 5,
        type: 'about',
        question: '如何登入共聲島？',
        answer: '<p><a href="LINK_ABOUTLOVE_ALL">點此網址</a> 立即登入共聲島！\n獲取更多資訊及不定期福利請加入<a href="LINE_OFFICIAL_URL">LINE官方帳號</a>。</p>',
    },
    {
        id: 6,
        type: 'howTo',
        question: '體驗時間多長？',
        answer: `<p>共聲島目前共有四種不同體驗：
                <ul>
                    <li>戀の時光町（導覽版）將由導覽員統一帶領，體體驗時間約為 1.5 小時，<strong>體驗完成後可獲得數位版</strong>。</li>
                    <li>戀の時光町（數位版）的體驗時間約為 1 小時。體驗過程中旅人能依照自己的步調，暫停與停留於周邊店家，不受時間約束。詳細比較可參考 <em>Q11</em> 導覽版與數位版差異。</li>
                    <li>限時轉運站的體驗內容包含與店家互動解謎，體驗時間可長可短，可依個人時間、興趣調整。</li>
                    <li>共聲電台的體驗時間約為 1 小時。體驗過程中旅人能依照自己的步調，停留於特定場域，不受時間約束。</li>
                </ul></p>`,
    },

    {
        id: 7,
        type: 'howTo',
        question: '是否有年齡限制？適不適合小孩玩？',
        answer: '<p>共聲島需於恆春鎮上步行移動，且需自備手機（使用個人 LINE 帳號）。基於行走安全，以及手機操作考量，建議 12 歲以下兒童由成人帶領並全程陪同遊玩。</p>',
    },
    {
        id: 8,
        type: 'howTo',
        question: '操作難度高不高？不太會用3C的年長者適不適合玩？',
        answer: '<p>共聲島的體驗模式皆以 LINE 介面為主要系統，只要會用 LINE 就能玩共聲島，歡迎加入 <a href="LINE_OFFICIAL_URL">LINE 官方帳號</a> 來試看看吧！</p>',
    },
    {
        id: 9,
        type: 'howTo',
        question:
            '非中文母語者可以體驗嗎？\n"I am a foreign tourist, if this game is suitable for me to participate in?"',
        answer: `<p>共聲島現有區域「戀の時光町」全內容皆為華語，不適合不擅長華語之遊客體驗。未來共聲島將推出無語言門檻之區域，敬請關注 <a href="IG_URL">共聲島 IG</a> 及官網。
        PeninSOUNDla is currently available in Mandarin only. We are working on the language-free version accessible to all audiences. Please follow our <a href="IG_URL">Instagram</a> and website for updates.</p>`,
    },
    {
        id: 10,
        type: 'howTo',
        question: '體驗共聲島可以獲得什麼？',
        answer: '<p>體驗共聲島可聽到恆春半島的故事、歷史和隱藏在場景裡的神秘聲響，沈浸於豐富多彩的「聲音」資料庫中。此外，透過手機的互動系統，可解謎、闖關、收集圖鑑；同時能與在地店家互動，邊吃、邊喝、邊閒聊、邊購物，交流彼此的故事，感受專屬於南國的人情味，最後帶著富含聲音、文化、故事、美食的獨特回憶滿載而歸。</p>',
    },

    {
        id: 11,
        type: 'howTo',
        question: '「戀の時光町」導覽版和數位版差在哪？',
        answer: `<p>「戀の時光町」分成<strong>導覽版</strong>及<strong>數位版</strong>兩個版本。
        <strong>導覽版</strong>：由真人導覽員全程陪同與解說，完成問卷還可獲得免費數位版。
        <strong>數位版</strong>：只需一支手機便能開始體驗，由手機 GPS 定位引領前行。玩家可自由調配時間，隨時開始與暫停。</p>`,
    },
    {
        id: 12,
        type: 'howTo',
        question: '有特殊的衣著、裝備嗎？',
        answer: '<p>體驗共聲島無服裝限制，每個人可視天氣及自身情況，自由穿著舒適之服裝（請勿裸體）。</p>',
    },

    {
        id: 13,
        type: 'howTo',
        question: '附近有停車場嗎',
        answer: '<p>恆春鎮設有立體停車場及公有停車場，歡迎使用。</p>\n<ul>\n<li><a href="https://maps.app.goo.gl/9TEvHai9gtD67aoe6">立體停車場位置</a></li>\n<li><a href="https://maps.app.goo.gl/7oi9Jg9BzCDrAnHQA">公有停車場位置</a></li>\n</ul>',
    },
    {
        id: 14,
        type: 'howTo',
        question: '附近有地方可以置物嗎？',
        answer: '<p>共聲島無專用置物區，建議旅人穿著輕便服裝參加體驗。</p>',
    },
    {
        id: 15,
        type: 'howTo',
        question: '如果在體驗過程中迷路了該怎麼辦？',
        answer: '<p>共聲島現有體驗皆不複雜，點位也很容易尋找，請不用擔心迷路問題。若在體驗過程中，仍對點位感到疑惑，可於LINE系統查看教學區塊。</p>',
    },
    {
        id: 16,
        type: 'purchase',
        question: '購買流程',
        answer: `<p>「戀の時光町（導覽版）」採預約制，於 KKday 販售中，每週五、六、日開團：</p><ol>
            <li>導覽預約：透過預約連結選擇人數與日期。</li>
            <li>收取信件：完成預約後，我們將發送相關事項（包含集合地點、注意事項等）至你的信箱。請注意收信，並完成指示。</li>
            <li>當天報到：活動當天帶著充飽電的手機至報到地點集合！</li>
        </ol>
        <p>其餘數位版體驗方案採包團制，請聯絡客服信箱 info@launcher.com.tw。</p>`,
    },

    {
        id: 17,
        type: 'purchase',
        question: '發票可以打統編嗎？',
        answer: '<p>若有抬頭和統編的發票需求，購買時請記得填妥相關資訊，購買完成後電子發票將會自動寄送到您的信箱。</p>',
    },

    {
        id: 18,
        type: 'purchase',
        question: '退費說明',
        answer: `<p>「戀の時光町（導覽版）」退費原則為：</p><ul>
            <li>於導覽活動發生日前第4日前取消，全額退費；</li>
            <li>於導覽活動發生日前第2日至第3日前取消，需收取旅遊費用全額30%手續費；</li>
            <li>於導覽活動發生日前第0日至第1日前取消，不可取消、更改訂單，亦不得請求退款。</li>
        </ul>`,
    },

    {
        id: 19,
        type: 'purchase',
        question: '可以包團嗎',
        answer: '<p>如有包團或其他客製化需求，請聯絡客服信箱 info@launcher.com.tw，客服將儘速與你聯繫。</p>',
    },
    {
        id: 20,
        type: 'purchase',
        question: '報名後卻不能出團的規則為何',
        answer: '<p>「戀的時光町（導覽版）」因有真人導覽行程，將參照以下規則出團：</p><ol>\n<li>活動7天前，若因未達最低成團人數將停止開放報名該場次。我們將以「Email」或「手機簡訊」通知已報名者，並將已繳費用全額退還。</li>\n<li>活動當日若因氣候不佳或不可抗力之因素、發布停班停課通知、中央氣象局發布「豪雨」或「豪大雨」特報*，我們將會以「Email」或「手機簡訊」通知該次活動取消，並將已繳費用將全額退還。</li>\n</ol>\n<p>若非上述理由而自行取消者，退費標準請參照 <em>Q18</em>。</p>\n<p>*參考<a href="https://www.cwb.gov.tw/V8/C/">天氣即時監測</a></p>',
    },
    {
        id: 21,
        type: 'device',
        question: '我需要準備什麼設備？',
        answer: '<p>若參與的體驗為「戀の時光町（導覽版）」不需自備耳機，導覽現場將提供全罩式無線耳機，無線耳機每場次使用完畢將進行擦拭消毒，現場亦備有衛生耳機套供索取。\n\n小提示：為了完整體驗，請事先充飽手機電量、確認手機 GPS 定位系統、相機可以正常運作。</p>',
    },

    {
        id: 22,
        type: 'device',
        question: '手機 GPS 定位壞掉怎麼辦？',
        answer: '<p>共聲島體驗結合數位及實地走訪，若自備的手機 GPS 定位壞掉，將無法體驗，請於體驗前確認。</p>',
    },
    {
        id: 23,
        type: 'device',
        question: '手機的相機壞掉怎麼辦？',
        answer: '<p>共聲島體驗中，部分互動會使用到相機，若自備手機的拍照功能壞掉，可跳過該互動步驟繼續進行體驗。</p>',
    },
    {
        id: 24,
        type: 'device',
        question: '有行動電源租借服務嗎？',
        answer: '<p>若臨時需要行動電源，可前往 ChargeSpot 站點租借喔！因此提醒：進行共聲島體驗前，請<strong>記得先充飽手機</strong>！</p>',
    },
];
